import store from '@/store'

export default [
  {
    path: '/admin/notification-templates',
    name: 'notification-template',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/notification-template')
  },
  {
    path: '/admin/notification-templates/create',
    name: 'notification-template-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/notification-template/create.vue')
  },
  {
    path: '/admin/notification-templates/:id/edit',
    name: 'notification-template-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/notification-template/edit.vue')
  }
]
